module.exports = __webpack_public_path__ + "img/ChevronDn-Brn.c7c144a5.png";